import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20digital%20entertainment%20background%20with%20flowing%20gradient%20waves%20in%20warm%20coral%20red%20and%20orange%20tones%2C%20geometric%20shapes%20floating%2C%20modern%20tech%20atmosphere%2C%20cinematic%20wide%20banner%20with%20soft%20glowing%20particles%2C%20dark%20bottom%20fading%20to%20lighter%20top&width=1800&height=800&seq=hero-bg-hongtao&orientation=landscape"
        alt="红桃tv高清视频娱乐平台"
        title="红桃tv - 高清视频娱乐平台官方入口"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 md:w-14 md:h-14 bg-primary-500/90 rounded-xl flex items-center justify-center backdrop-blur-sm">
            <i className="ri-heart-fill text-background-50 text-2xl md:text-3xl"></i>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl text-background-50">
            红桃tv
          </h1>
        </div>

        <p className="text-base md:text-xl text-background-50/90 max-w-2xl mb-2 leading-relaxed">
          高清视频娱乐平台 — 海量影视、综艺、直播，随时随地畅享优质视听体验
        </p>
        <p className="text-sm md:text-base text-background-50/70 max-w-xl mb-8 leading-relaxed">
          高清流畅不卡顿，内容持续更新，精彩不间断
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/dianshi"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm md:text-base transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 backdrop-blur-sm font-medium rounded-md text-sm md:text-base transition-all border border-background-50/30 whitespace-nowrap"
          >
            <i className="ri-download-line mr-2"></i>
            下载APP
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">1.2亿+</p>
            <p className="text-xs md:text-sm text-background-50/70">月活跃用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">50万+</p>
            <p className="text-xs md:text-sm text-background-50/70">小时内容</p>
          </div>
          <div className="w-px h-10 bg-background-50/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">8大</p>
            <p className="text-xs md:text-sm text-background-50/70">内容品类</p>
          </div>
        </div>
      </div>
    </section>
  );
}